import React from "react";
import { type Dayjs } from "dayjs";
import Date from "Pages/MyScheduleBeta/Components/FiltersSchedule/Date";
import { DAY_WEEK_TYPE } from "Pages/MyScheduleBeta/utils/constants";

interface FilterFormBodyProps {
  selectedSubject: string;
  setSelectedSubject: (subject: string) => void;
  dateValue: Dayjs | [Dayjs, Dayjs] | null;
  setDateValue: (dates: Dayjs | [Dayjs, Dayjs] | null) => void;
  subjects?: any;
}

const labelStyle: React.CSSProperties = {
  fontSize: "13px",
  fontWeight: 700,
  color: "#64748b",
  letterSpacing: "0.5px",
  display: "block",
  marginBottom: "8px",
};

const FilterFormBody: React.FC<FilterFormBodyProps> = ({
  selectedSubject,
  setSelectedSubject,
  dateValue,
  setDateValue,
  subjects,
}) => {
  return (
    <div
      style={{
        padding: "24px 0px",
        display: "flex",
        flexDirection: "column",
        gap: "24px",
        overflowY: "auto",
        flex: 1,
      }}
    >
      {/* Date Picker Section */}
      <div>
        <label style={labelStyle}>DATE RANGE</label>
        <div style={{ fontWeight: 550 }}>
          <Date
            eventType={DAY_WEEK_TYPE.WEEK}
            dateRangeLimit={7}
            value={dateValue}
            onChange={setDateValue}
          />
        </div>
      </div>

      {/* Subject Filter */}
      <div>
        <label style={labelStyle}>SUBJECT</label>
        <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
          {subjects?.map((subject: any) => {
            const isSelected = selectedSubject === subject.subjectName;
            return (
              <button
                key={subject?.id}
                type="button"
                onClick={() => setSelectedSubject(subject?.subjectName)}
                style={{
                  padding: "8px 20px",
                  borderRadius: "20px",
                  fontSize: "13px",
                  fontWeight: 700,
                  cursor: "pointer",
                  transition: "all 0.2s ease",
                  border: isSelected ? "none" : "1px solid #e2e8f0",
                  backgroundColor: isSelected ? "#00a3d9" : "#ffffff",
                  color: isSelected ? "#ffffff" : "#475569",
                  boxShadow: isSelected
                    ? "0 4px 10px rgba(0, 163, 217, 0.2)"
                    : "none",
                }}
              >
                {subject?.subjectName}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default FilterFormBody;
